import { render, staticRenderFns } from "./Best20Image.vue?vue&type=template&id=17fffd8e&scoped=true"
import script from "./Best20Image.vue?vue&type=script&lang=js"
export * from "./Best20Image.vue?vue&type=script&lang=js"
import style0 from "./Best20Image.vue?vue&type=style&index=0&id=17fffd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fffd8e",
  null
  
)

export default component.exports